import axios from 'axios';
import {globalActions} from '../store/global-actions';

function initListReviewComponents(app) {
    const listingReviewBase = {
        props: {
            listingId: {required: true},
            ownerId: {required: true},
            url: {required: true},
            messages: {required: true},
            isOwner: {required: true, type: Boolean},
            listingType: {required: true},
            starInfo: {required: true},
            pointName: {required: true},
            categoryName: {required: true},
            userInfo: {required: true},
            initialReviewList: {required: false},
            label: {required: false},
            engageCookie: {type: String},
        },
        data() {
            return {
                reviewList: this.initialReviewList,
                ratings: this.starInfo.ratings,
                tooltips: this.starInfo.tooltips != null ? this.starInfo.tooltips : '',
                showDetails: false,
                isUserAuthenticated: this.userInfo.isAuthenticated,
                isUserEmailConfirmed: this.userInfo.isEmailConfirmed,
                visibleReviewsCount: 5,
            };
        },
        computed: {
            totalReviewRating() {
                const totalRatingList = this.reviewList.map((a) => a.totalRating);
                return (totalRatingList.length > 0 ? totalRatingList.reduce((a, b) => a + b, 0) / totalRatingList.length : 0).toFixed(1);
            },
            showLabel() {
                return this.label && (this.isOwner || !this.reviewList.length);
            },
            lastReviews() {
                return this.reviewList.slice(-1 * this.visibleReviewsCount).reverse();
            },
        },
        methods: {
            createReview() {
                if (!this.isUserAuthenticated) {
                    globalActions.changePreselectRegistrationReason(globalActions.getRateRegistrationPlace());
                    this.showLoginRegisterModal();
                } else if (!this.isUserEmailConfirmed) {
                    globalActions.openInfoModal(this.messages.errorHeader, this.messages.emailNotConfirmedMessage);
                } else {
                    const data = {
                        listingId: this.listingId,
                        ownerId: this.ownerId,
                        listingType: this.listingType,
                        ratings: this.getRatings(),
                    };

                    axios.post(this.url, data)
                        .then((review) => {
                            this.reviewList.push(review.data);
                            localStorage.removeItem('reviewRatings');
                            globalActions.preventShowingEngage(this.engageCookie);
                        })
                        .catch((error) => this.showAjaxErrorModal(error));
                }
            },
            showAjaxErrorModal(error) {
                let messageBody = this.messages.badRequestMessage;
                if (error.status === 403) {
                    messageBody = this.messages.forbiddenMessage;
                }

                globalActions.openInfoModal(this.messages.errorHeader, messageBody);
            },
            showLoginRegisterModal() {
                localStorage.setItem('reviewRatings', JSON.stringify(this.ratings));
                globalActions.openLoginModal();
            },
            getRatings() {
                return this.ratings.map((r) => {
                    const rating = {};
                    rating[this.categoryName] = r.key;
                    rating[this.pointName] = r.value;
                    return rating;
                });
            },
            getRatingLabel(key) {
                return this.starInfo.names.find((n) => n.value === key).label;
            },
            getTooltips(key) {
                return this.starInfo.tooltips.find((n) => n.key === key).value;
            },
        },
        created() {
            const ratings = localStorage.getItem('reviewRatings');
            if (ratings) {
                this.ratings = JSON.parse(ratings);
                this.showDetails = true;
            }
        },
    };

    app.component('listing-review-default', {
        extends: listingReviewBase,
        template: '#listing-review-default',
    });

    app.component('listing-review-custom', {
        extends: listingReviewBase,
        template: '#listing-review-custom',
    });
}

export default initListReviewComponents;
